import { CEFR_LEVELS } from '@repo/config';
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { grammarPointSummarySchema } from '../schemas';

const grammarFamilySchema = z.object({
  family: z.string(),
  points: z.array(grammarPointSummarySchema),
});

const grammarBookLevelSchema = z.object({
  level: z.enum(CEFR_LEVELS),
  families: z.array(grammarFamilySchema),
});

const getGrammarBookV1DataSchemaDefinition = z.object({
  levels: z.array(grammarBookLevelSchema),
});

export const getGrammarBookV1DataSchema: typeof getGrammarBookV1DataSchemaDefinition =
  getGrammarBookV1DataSchemaDefinition;

export type IGetGrammarBookV1Data = z.infer<typeof getGrammarBookV1DataSchema>;

export const getGrammarBookV1ResponseSchema: z.ZodSchema<IAPI<IGetGrammarBookV1Data>> =
  createApiResponseSchema(getGrammarBookV1DataSchema) as z.ZodSchema<IAPI<IGetGrammarBookV1Data>>;

export type IGetGrammarBookV1Response = IAPI<IGetGrammarBookV1Data>;
